@for (tool of toolsSg(); track tool.id) {
  <button
    class="atn-ds-table-row-tools__tool"
    [class.atn-ds-table-row-tools__tool--disabled]="tool.disabled"
    [class.atn-ds-table-row-tools__tool--loading]="tool.loading"
    [attr.aria-label]="tool.label ?? tool.title ?? tool.id"
    [attr.aria-disabled]="tool.disabled || tool.loading"
    [attr.title]="tool.title"
    type="button"
    (click)="toolClickHandler($event, tool)"
  >
    @if (tool.iconClass) {
      <i [class]="tool.iconClass"></i>
    } @else if (tool.label) {
      <span>{{ tool.label }}</span>
    }
  </button>
}
